/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_Search_SuccessInputs */

const es_tools_outlook_search_success = /** @type {(inputs: Tools_Outlook_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda en Outlook completada`)
};

const en_tools_outlook_search_success = /** @type {(inputs: Tools_Outlook_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outlook search complete`)
};

/**
* | output |
* | --- |
* | "Outlook search complete" |
*
* @param {Tools_Outlook_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_search_success = /** @type {((inputs?: Tools_Outlook_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_search_success(inputs)
	return en_tools_outlook_search_success(inputs)
});
export { tools_outlook_search_success as "tools.outlook.search_success" }